export default __webpack_public_path__ + "static/media/ic_phone.3dc564a8.svg";